const getThreadWorkspaceName = (threads = []) => {
  const repoPath = threads?.[0]?.repoPath;

  if (!repoPath) {
    return 'Workspace';
  }

  const normalized = String(repoPath).replace(/\\/g, '/');
  const parts = normalized.split('/').filter(Boolean);

  return parts[parts.length - 1] || 'Workspace';
};

export default getThreadWorkspaceName;
